
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import layout from '@/layout/page-with-header'
import ListTable from './ListTable'
import EntryDialog from './EntryDialog'
const components = {
  layout,
  ListTable,
  EntryDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = {
  ...mapGetters({
    isLoading: `OpPurchase/Summarize/loadingState`,
  }),
}

/**
 * Methods
 *
 */
const methods = mapActions({
  reload: `OpPurchase/Summarize/fetchData`,
})

methods.goToAccount = function() {
  this.$router.push(`/oppurchase/account`)
}

methods.addNewRecord = function() {
  this.$refs.EntryDialog.new()
}

methods.editRecord = function(id) {
  this.$refs.EntryDialog.edit(id)
}

/**
 * Event OnMounted
 *
 */
const mounted = function() {
}

/**
 * Event OnCreated
 *
 */
const created = function() {
  this.$store.commit(`set_page_title`, `Operasional Toko`)
  this.$store.commit(`set_breadcrumb`, [ `Akun`, `Transaksi` ])
}

export default {
  components,
  data,
  computed,
  methods,
  mounted,
  created,
}
</script>

<style scoped>
</style>

<template>
  <layout>
    <Row>
      <BlockTable :loading="isLoading">
        <template #header>
          Transaksi Akun

          <div class="pull-right">
            <ButtonL icon="repeat" color="default" @click="reload" />
            <ButtonL text="Daftar Akun" color="default" @click="goToAccount" />
            <ButtonL text="Kredit / Debit" color="primary" @click="addNewRecord" />
          </div>
        </template>
        <template #content>
          <ListTable @editrequest="editRecord" />
        </template>
      </BlockTable>
    </Row>

    <EntryDialog ref="EntryDialog"></EntryDialog>
  </layout>
</template>